import React from 'react';
import dayjs from 'dayjs';
import { Link, useLocation } from 'react-router-dom';
import { EProjectStatus } from '@/enums';
import { cn } from '@/lib/utils';
import Routes from '@/router/routes';
import { projectStatusColors, projectStatusLabel } from '@/utils/projectStatusLabelAndColors';
import WorkspaceProjectActionsDD from '../dropdowns/WorkspaceProjectActionsDD';
import { MyWorkspaceGridViewProps, Project } from '@/types';

function MyWorkspaceGridView({
  projects,
  currentTheme,
  mergedWorkspaces,
  isUserOwner,
  isUserEditor,
}: MyWorkspaceGridViewProps) {
  const { pathname } = useLocation();

  const removePreviousConversationFromStorage = (id: string) => {
    localStorage.removeItem(`current_conversation_id/test/${id}`);
  };

  const getStatusLabel = (status: EProjectStatus): string => projectStatusLabel[status];
  const getStatusColor = (status: EProjectStatus): string => projectStatusColors[status];

  return (
    <div className="grid grid-cols-6 gap-4 max1420:grid-cols-5 max1250:grid-cols-4 max1050:grid-cols-3 md900:grid-cols-2 md700:grid-cols-1">
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {React.Children.toArray(
        projects?.map((item: Project) => (
          <div className="flex flex-col transition-all min-w-[180px] auto-cols-min ease-in border rounded-md shadow hover:shadow-lg hover:scale-[1.02] h-fit relative">
            {/* responses */}
            <div className="absolute text-xs top-3.5 left-2">
              <p>
                {item?.respondents_max
                  ? `${item?.completed_count} / ${item?.respondents_max}`
                  : '/'}
              </p>
            </div>
            {/* status */}
            <span
              className={cn(
                'absolute text-xs font-semibold top-3 right-3 rounded-full px-3 py-0.5',
                getStatusColor(item?.status),
              )}
            >
              {getStatusLabel(item?.status)}
            </span>
            <Link
              onClick={() => removePreviousConversationFromStorage(item?._id)}
              to={`${pathname}${Routes.project_design.path}/${item?._id}`}
              className="flex items-center justify-center w-full h-48 p-3 overflow-hidden font-medium text-center"
            >
              {item.title}
            </Link>
            <div className="flex items-center justify-between w-full p-3 border-t h-14">
              <div
                style={{ color: currentTheme?.['secondary-text'] }}
                className="mb-1 text-sm max-w-[160px] truncate"
              >
                {dayjs(item?.updatedAt).format('DD/MMM/YYYY')}
              </div>
              <WorkspaceProjectActionsDD
                mergedWorkspaces={mergedWorkspaces}
                targettedProjectID={item?._id}
                isUserOwner={isUserOwner}
                isUserEditor={isUserEditor}
                projectTitle={item?.title}
                projectStatus={item?.status}
              />
            </div>
          </div>
        )),
      )}
    </div>
  );
}

export default MyWorkspaceGridView;
